// extracted by mini-css-extract-plugin
export default {"cls1":"ikCqWulR_2f3nITbAMee","cls2":"FzJvt75POS3ge2TwJnB7 ikCqWulR_2f3nITbAMee"};